import { render, staticRenderFns } from "./editOwner.vue?vue&type=template&id=4971e54a&scoped=true"
import script from "./editOwner.vue?vue&type=script&lang=js"
export * from "./editOwner.vue?vue&type=script&lang=js"
import style0 from "./editOwner.vue?vue&type=style&index=0&id=4971e54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4971e54a",
  null
  
)

export default component.exports